import { Box, BoxProps, ColorOptions, FileSelector, Loader, ModalDialog, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { isEmptyObject } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import XlsxPopulate from 'xlsx-populate'
import ActionsMenu from '../../components/ActionMenu/ActionsMenu'
import { HorizontalLoader } from '../../components/HorizontalLoader'
import { NewTable } from '../../components/NewTable'
import Tabbar, { TabbarType } from '../../components/Tabbar'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { isEmpty, MessageTypes } from '../../utils'
import { getCustomColumnWidth, getSelectedDate, postReconHeaders } from '../../utils/constants'

const defaultTitles = [{ title: 'Approve Payouts' }, { title: 'Release Payouts' }]
const columnsWithAction = [
  'Created At',
  'Settlement Net Amount',
  'Status',
  'Payout Sequence Number',
  'Original Transaction Id',
  'Jiopay Transaction Id',
  'Merchant Id',
  'Payout Initiated Date',
  'Payout Date',
  'Group ID',
  'SubGroup ID',
  'Action',
]

const columnsWithoutAction = [
  'Created At',
  'Settlement Net Amount',
  'Status',
  'Payout Sequence Number',
  'Original Transaction Id',
  'Jiopay Transaction Id',
  'Merchant Id',
  'Payout Initiated Date',
  'Payout Date',
  'Group ID',
  'SubGroup ID',
]

const Header = ({}: any) => {
  return (
    <Box {...styles.header}>
      <Text title={'Post Recon'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
    </Box>
  )
}
const PostRecon = () => {
  const {
    searchTxns,
    getTransactions,
    updateSelectedDateInfo,
    selectedDateInfo,
    getTransactionsByDate,
    bulkPayoutUpdate,
    setMessage,
    currentPage,
    updateSelectedRowIndex,
    getRowsSelected,
    generatePayoutUpdate,
    singlePayoutUpdate,
    getSelectedPayoutDate,
    percent,
    isSelectionChanged,
    makerAccessConfig,
    checkerAccessConfig,
    fetchAccess,
  } = useStores((root) => ({
    searchTxns: root.postRecon.searchTxns,
    getTransactions: root.postRecon?.getTransactions,
    updateSelectedDateInfo: root.updateSelectedDateInfo,
    selectedDateInfo: root.selectedDateInfo,
    getTransactionsByDate: root.postRecon?.getTransactionsByDate,
    bulkPayoutUpdate: root.postRecon.bulkPayoutUpdate,
    setMessage: root.message.setMessage,
    currentPage: root.pagination.number,
    updateSelectedRowIndex: root.postRecon.updateSelectedRowIndex,
    getRowsSelected: root.postRecon.getRowsSelected,
    generatePayoutUpdate: root.postRecon.generatePayoutUpdate,
    singlePayoutUpdate: root.postRecon.singlePayoutUpdate,
    getSelectedPayoutDate: root.postRecon.getSelectedPayoutDate,
    percent: root.postRecon.progress,
    isSelectionChanged: root.postRecon.isSelectionChanged,
    makerAccessConfig: root.user.getAccessConfig(['post_recon', 'maker']),
    checkerAccessConfig: root.user.getAccessConfig(['post_recon', 'checker']),
    fetchAccess: root.user.getAccessConfig(['post_recon', 'fetch']),
  }))
  const { width } = useWindowDimensions()
  const [lazySearch, { state: searchApiState }] = useLazyApiData(searchTxns)
  const [lazyGeneratePayoutUpdate, { state: generatePayoutState }] = useLazyApiData(generatePayoutUpdate)
  const [lazySinglePayoutUpdate, { state: singlePayoutUpdateState }] = useLazyApiData(singlePayoutUpdate)

  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [isUpdateLoading, setUpdateLoading] = useState(false)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [showFileUpload, setShowFileUpload] = useState(false)
  const [filename, setFilename] = useState('')
  const [txns, setTxns] = useState<any>([])
  const [allRecords, setAllRecords] = useState<any>([])
  const [inputKeys, setInputkeys] = useState<any>([])
  const [wsdata, setWsData] = useState<XlsxPopulate.Workbook>()
  const [isReleaseEnabled, setEnableRelease] = useState(false)
  const [isApiCalledPostUpdate, setIsApiCalledPostUpdate] = useState(false)

  useEffect(() => {
    updateSelectedDateInfo({
      fromDate: getSelectedDate(5),
      toDate: selectedDateInfo?.toDate ?? new Date(Date.now()),
      position: {
        top: selectedDateInfo?.position?.top ?? 0,
        left: selectedDateInfo?.position?.left ?? 0,
        visible: selectedDateInfo?.position?.visible ?? false,
      },
      dateLabel: 'Last 3 days',
    })
    lazySearch(selectedTabIndex)
    setLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTabIndex])

  // const listData = getTransactions(selectedTabIndex)
  useEffect(() => {
    if (searchApiState === 'fulfilled' || searchApiState === 'rejected') {
      setListData(getTransactions(selectedTabIndex))
      setLoading(false)
    }
  }, [getTransactions, isSelectionChanged, searchApiState, selectedTabIndex])

  useEffect(() => {
    if ((generatePayoutState === 'fulfilled' || singlePayoutUpdateState === 'fulfilled') && !isApiCalledPostUpdate) {
      lazySearch(selectedTabIndex)
      setIsApiCalledPostUpdate(true)
    }
  }, [generatePayoutState, isApiCalledPostUpdate, lazySearch, selectedTabIndex, singlePayoutUpdateState])

  const onTabSelected = (index: number) => {
    setSelectedTabIndex(index)
    setEnableRelease(false)
  }
  const onPress = (item: any) => {}

  const fetchDataOnChange = () => {
    lazySearch(selectedTabIndex)
  }

  const onHoldReleaseUpload = () => {
    if (selectedTabIndex === 0) {
      console.log('onHoldReleaseUpload', selectedTabIndex)
      setWsData(undefined)
      setFilename('')
      setShowFileUpload(true)
    } else if (selectedTabIndex === 1) {
      console.log('onHoldReleaseUpload', selectedTabIndex)
      lazyGeneratePayoutUpdate(getSelectedPayoutDate(selectedTabIndex))
      setIsApiCalledPostUpdate(false)
    }
  }

  const onReleasePayout = () => {
    console.log('onReleasePayout')
    lazySinglePayoutUpdate(getSelectedPayoutDate(selectedTabIndex))
    setIsApiCalledPostUpdate(false)
  }

  const onItemChecked = (isChecked: boolean, index: any, rowData: any) => {
    if (rowData) {
      updateSelectedRowIndex(currentPage - 1, index, rowData, isChecked, selectedTabIndex)
      const rowsChecked = getRowsSelected(selectedTabIndex)
      setEnableRelease(rowsChecked.length > 0)
    }
  }

  const onDownloadRow = (type: any, id: any, itemData: any) => {
    const date = `${itemData?.postReconDate?.split('/')?.[2]}-${itemData?.postReconDate?.split('/')?.[1]}-${
      itemData?.postReconDate?.split('/')?.[0]
    }`

    const modifiedTableData = JSON.parse(JSON.stringify(getTransactionsByDate(date, selectedTabIndex)))
    modifiedTableData?.forEach((item) => {
      if (selectedTabIndex === 0) {
        columnsWithAction?.forEach((key) => {
          if (item[key as keyof typeof item] === undefined) {
            item[key as keyof typeof item] = ''
          }
        })
      } else {
        columnsWithoutAction?.forEach((key) => {
          if (item[key as keyof typeof item] === undefined) {
            item[key as keyof typeof item] = ''
          }
        })
      }
    })

    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push(selectedTabIndex === 0 ? [...columnsWithAction] : [...columnsWithoutAction])
      modifiedTableData.map((item: any, index: number) => {
        data.push([...Object.values(item)])
      })

      workbook.sheet(0)?.cell('A1').value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `PostRecon_${new Date()}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }
  const isValidEntry = (obj: any) => {
    const values = Object.values(obj)
    const isValidColumns = values?.filter((item: string) => !isEmpty(item))?.length > 0
    return !isEmptyObject(obj) && isValidColumns
  }

  const readExcel = async (file: any, name: string) => {
    if (!file) {
      setFilename(name)
      setWsData(undefined)
      return
    }
    // setLoading(true)
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setFilename(name)
          setWsData(workbook)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          const allTxns: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                let val = `${String(row._cells[i]?.value() ?? '')?.trim()}`
                obj[key] = val
              }
            }
            if (rowIndex > 1) {
              if (
                obj?.Action === '' ||
                obj?.Action?.toUpperCase() === 'RELEASE' ||
                obj?.Action?.toUpperCase() === 'HOLD'
              ) {
                // consider only empty Action cells or with value RELEASE
                if (obj?.Action === '' || obj?.Action?.toUpperCase() === 'RELEASE') {
                  //push only Payout Sequence Number column values
                  if (isValidEntry(obj)) {
                    values.push(`${obj?.['Payout Sequence Number']}`)
                    allTxns.push(obj)
                  }
                }
              } else {
                setShowFileUpload(false)
                reject('Invalid File: No Action Column or Action column has invalid entries')
                setWsData(undefined)
                setFilename('')
              }
            }
          })
          const isExcelInvalid =
            selectedTabIndex === 0
              ? columnsWithAction.some((item) => !keys.includes(item))
              : columnsWithoutAction.some((item) => !keys.includes(item))

          if (!isExcelInvalid) {
            console.log('Post Recon Txns: ', values)
            if (values?.length > 0) {
              setTxns(values)
              setAllRecords(allTxns)
              setInputkeys(keys)
              resolve(values)
            } else {
              setShowFileUpload(false)
              RootStore.message.setMessage('No valid transactions to upload', MessageTypes.INFO)
            }
          } else {
            setShowFileUpload(false)
            reject('Invalid File')
          }
        })
        .catch(() => {
          setShowFileUpload(false)
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setWsData(undefined)
      setFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    // setLoading(false)
  }

  const writeToResultFile = (errorData: any, fileName: string) => {
    let transformedData: any = []
    const modifiedMidData = JSON.parse(JSON.stringify(allRecords))
    transformedData = errorData.map((item) => [item.status, item.message, item.code])
    transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push([...inputKeys, ...transformedData[0]])
      modifiedMidData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[1]])
      })

      workbook.sheet(0)?.cell('A1').value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `Result_${fileName}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  const writeToResultFileinChunks = (errorData: any, fileName: string) => {
    let transformedData: any = []
    const modifiedMidData = JSON.parse(JSON.stringify(allRecords))

    transformedData = errorData.map((item) => {
      return item.map((subItem) => [subItem.status, subItem.message, subItem.code])
    })
    transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push([...inputKeys, ...transformedData[0]])
      const { REACT_APP_POST_RECON_PER_UPLOAD_COUNT } = window?._env_
      modifiedMidData.map((item: any, index: number) => {
        const rowIndex = Math.floor(index / +REACT_APP_POST_RECON_PER_UPLOAD_COUNT + 1)
        data.push([...Object.values(item), transformedData[rowIndex]])
      })

      workbook.sheet(0)?.cell('A1').value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `Result_${fileName}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }
  const onBulkUpload = async (apiCall: any, loaderFunc: (b: boolean) => void, fileName: string) => {
    let errorData: any[] = []
    const { REACT_APP_POST_RECON_PER_UPLOAD_COUNT } = window?._env_
    if (txns?.length <= +REACT_APP_POST_RECON_PER_UPLOAD_COUNT) {
      loaderFunc(true)
      errorData = await apiCall(txns)
      if (errorData?.length > 0) {
        setShowFileUpload(false)
      }
      loaderFunc(false)
      writeToResultFile(errorData, fileName)
    } else {
      for (let i = 0; i < txns.length; i += +REACT_APP_POST_RECON_PER_UPLOAD_COUNT) {
        const chunkList = txns.slice(i, i + +REACT_APP_POST_RECON_PER_UPLOAD_COUNT)
        loaderFunc(true)
        const errors = await apiCall(chunkList)
        errorData.push(errors)
        loaderFunc(false)
      }
      writeToResultFileinChunks(errorData, fileName)
    }
  }

  const handlePress = () => {
    onBulkUpload(bulkPayoutUpdate, setUpdateLoading, filename)
  }

  return (
    <Box {...styles.container} padding={16}>
      <>
        <ModBox
          show={percent < 100 && percent > 0}
          alignItems={'center'}
          justifyContent={'center'}
          w={'100%'}
          h={'100%'}>
          <Box alignItems={'center'} justifyContent={'center'}>
            <HorizontalLoader state={percent} />
            <Spacer size={8} />
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
              {'Loading...'}
            </Text>
          </Box>
        </ModBox>
        <ModBox show={percent < 26} w={'100%'} h={'100%'} alignItems={'center'} justifyContent={'center'}>
          <Loader />
          <Spacer size={8} />
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
            {'Loading...'}
          </Text>
        </ModBox>
        <ModBox show={!isLoading && percent === 100 && fetchAccess} width={800}>
          <Header />
          <ModBox marginBottom={16}>
            <Tabbar
              titles={defaultTitles}
              default={selectedTabIndex}
              type={TabbarType.bulkEntity}
              onSelected={onTabSelected}
            />
            <ActionsMenu
              fetchDataOnChange={fetchDataOnChange}
              filterVisible={false}
              setFilterVisible={null}
              showSearch={false}
              enableFilter={false}
              showCalendar
              defaultPage={1}
              type="postRecon"
              filterApplied={false}
              showPagination={false}
            />
          </ModBox>
          <ModBox>
            <NewTable
              data={listData}
              rowHeight={48}
              headerHeight={64}
              height={492}
              customWidthFunc={getCustomColumnWidth}
              tableWidth={800}
              headerRowKeys={postReconHeaders}
              onRowClick={onPress}
              freezeColumn={'check'}
              freezeColumnWidth={50}
              onCheckChange={onItemChecked}
              onAction={onDownloadRow}
              showHeaderCheckBox={false}
            />
          </ModBox>
          <ModalDialog
            type="CenteredWrap"
            children={
              <ModBox
                backgroundColor={'WHITE'}
                padding={32}
                borderRadius={8}
                alignItems={'center'}
                justifyContent={'center'}>
                <FileSelector
                  innerCompTitle={'Please upload Post Recon Update file'}
                  innnerCompSubtitle={'Browse your file'}
                  onFileSelect={readExcel}
                  fileType=".xlsx"
                  filename={filename}
                />
                <Spacer size={16} />
                <ButtonNew
                  disabled={!wsdata}
                  paddingVertical={16}
                  title={'Update'}
                  isLoading={isUpdateLoading}
                  type="primary"
                  onPress={handlePress}
                />
              </ModBox>
            }
            show={showFileUpload}
            onDismiss={() => setShowFileUpload(false)}
            onClose={() => setShowFileUpload(false)}
          />
          <ModBox marginVertical={8}>
            <ModBox
              show={selectedTabIndex === 0 && makerAccessConfig}
              direction="row"
              alignItems={'center'}
              justifyContent={'space-between'}>
              <ButtonNew title={'Hold/Release'} onPress={onHoldReleaseUpload} />
              <ButtonNew
                title={'Release Payout'}
                onPress={onReleasePayout}
                disabled={!isReleaseEnabled}
                isLoading={singlePayoutUpdateState === 'pending'}
              />
            </ModBox>
            <ModBox
              w={'100%'}
              show={selectedTabIndex === 1 && checkerAccessConfig}
              direction="row"
              alignItems={'flex-end'}
              justifyContent={'flex-end'}>
              <ButtonNew
                title={'Release Payout'}
                onPress={onHoldReleaseUpload}
                disabled={!isReleaseEnabled}
                isLoading={generatePayoutState === 'pending'}
              />
            </ModBox>
          </ModBox>
        </ModBox>
      </>
    </Box>
  )
}

export default PostRecon

export const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    minHeight: 720,
    overflow: 'auto',
  } as BoxProps,
  header: {
    pv: 16,
    h: 40,
    w: '100%',
    marginBottom: 16,
  } as BoxProps,
  footer: {
    p: 12,
    direction: 'row',
    justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  progressView: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 72,
    height: 72,
    alignItems: 'center',
    zIndex: 10000,
    justifyContent: 'center',
  } as BoxProps,
}
